import { render, staticRenderFns } from "./activeWonderful.vue?vue&type=template&id=2ce7e61c&scoped=true&"
import script from "./activeWonderful.vue?vue&type=script&lang=js&"
export * from "./activeWonderful.vue?vue&type=script&lang=js&"
import style0 from "./activeWonderful.vue?vue&type=style&index=0&id=2ce7e61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7e61c",
  null
  
)

export default component.exports